import form from '@/mixins/crud-form';
import utils from '@/utils/index';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEPT_DETAIL',
        create: 'DEPT_CREATE',
        update: 'DEPT_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'dept_name',
        default: '',
        label: '部门名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.dept_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dept_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'parent_id',
        default: 0,
        label: '上级部门',
        render: function render() {
          return h("d2-tree-popover", {
            "attrs": {
              "source": "DEPT_ALL",
              "key-label": "dept_name"
            },
            "model": {
              value: _this.form.model.parent_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "parent_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'leader',
        default: '',
        label: '负责人',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.leader,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "leader", $$v);
              }
            }
          });
        }
      }, {
        prop: 'email',
        default: '',
        label: '部门邮箱',
        rule: {
          validator: utils.helper.isLegalEmailValidator,
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.email,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "email", $$v);
              }
            }
          });
        }
      }, {
        prop: 'phone',
        default: '',
        label: '部门电话',
        rule: {
          validator: utils.helper.isLegalMobilePhoneValidator,
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.phone,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'order_num',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示排序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.order_num,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "order_num", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};